import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async createTool({ dispatch, commit }, payload) {
    return Vue.axios
      .post(Vue.$url("tool"), payload)
      .then((rsp) => {
        dispatch('fetchTools')
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Tool', 1: payload.description }), { root: true })
        return rsp.data;
      })
      
  },

  async fetchTools({ commit }, active = -1) {
    let query = "?isDel=";
    if (active > -1) {
      query += active ? false : true;
    }

    return Vue.axios.get(Vue.$url("tool" + query))
      .then((rsp) => commit("SET_TOOLS", rsp.data))
      
  },
  
  async fetchNextMaxCode({ commit }) {
    return Vue.axios.get(Vue.$url("tool/max-code"))
      .then((rsp) =>  {
        commit('SET_NEXT_SEQ_CODE', rsp.data)
        return rsp.data;
      })
      .catch((err) => Vue.$err(err) && commit('mShowErrorMessage', err.data.Message, { root: true }))
  },

  async updateTool({ dispatch, commit }, payload) {
    return Vue.axios
      .put(Vue.$url("tool/" + payload.id), payload)
      .then((rsp) => {
        dispatch('fetchTools');
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Tool', 1: payload.description }), { root: true });
        return rsp.data;
      })
      
  },

  async deleteTool({ dispatch, commit }, payload) {
    Vue.$log.debug('trying to delete Tool', payload.id);
    return Vue.axios
      .delete(Vue.$url("tool/" + payload.id))
      .then(() => dispatch('fetchTools') && commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true }))
      
  },
}